import {
  WSElement,
  WSGrid,
  WSList,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYMENT_METHOD,
  PATH_SETTINGS_PAYMENT_METHODS_MANAGE_PAYMENT_METHOD
} from "..";
import { useUserId } from "../../../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../../../query/hooks/useFeatureFlags";
import { useQueryCustomerEntity } from "../../../../../query/onboarding/queries/useQueryCustomerEntity";
import { useMemberProfile } from "../../../../../query/users/queries";
import { selectorUseInternationalPayouts } from "../../../../../shared/selectors/selectorUseInternationalPayouts";
import { usePaymentsSettingsManagedByOrganization } from "../../../../../userFeatures/usePaymentsSettingsManagedByOrganization";
import { PayoutSplits } from "../../../components/PayoutSplits";
import { WingspanAccounts } from "../../../components/WingspanAccounts";
import { WidgetPlatformBalance } from "../../../../PlatformBalance/components/WidgetPlatformBalance";
import { WidgetPlatformBalanceInfo } from "../../../../PlatformBalance/components/WidgetPlatformBalanceInfo";
import { AlertNoPayoutMethod } from "../../../components/AlertNoPayoutMethod";
import { AlertPayoutMethodMissingData } from "../../../components/AlertPayoutMethodMissingData";
import { AlertPendingAccountMicroDeposit } from "../../../components/AlertPendingAccountMicroDeposit";
import { DefaultPaymentMethod } from "../../../components/payment/DefaultPaymentMethod";
import { DefaultPayoutMethod } from "../../../components/payout/DefaultPayoutMethod";

export const RouteIndex: React.FC = () => {
  const featureFlags = useFeatureFlags();
  const userId = useUserId();
  const hasManagedPayments = !!usePaymentsSettingsManagedByOrganization();
  const history = useHistory();

  const queryMember = useMemberProfile(userId);
  const queryCustomerEntity = useQueryCustomerEntity();

  const isInternational = useMemo(
    () =>
      queryMember.data
        ? selectorUseInternationalPayouts(
            queryMember.data,
            queryCustomerEntity.data
          )
        : false,
    [queryMember.data, queryCustomerEntity.data]
  );

  if (hasManagedPayments) {
    return (
      <>
        <WSPageToolbar title="Payment method" />

        <WSGrid gutter={{ m: "3XL" }}>
          <WSGrid.Item span={{ m: "7" }}>
            <WSList gap="2XL">
              <AlertPendingAccountMicroDeposit />
              <DefaultPaymentMethod
                onManage={() => {
                  history.push(
                    PATH_SETTINGS_PAYMENT_METHODS_MANAGE_PAYMENT_METHOD
                  );
                }}
                onAddNew={() => {
                  history.push(
                    PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYMENT_METHOD
                  );
                }}
              />
            </WSList>
          </WSGrid.Item>
        </WSGrid>
      </>
    );
  }
  return (
    <>
      <WSPageToolbar title="Payout & payment methods" />

      <WSGrid gutter={{ m: "3XL" }}>
        <WSGrid.Item span={{ m: "7" }}>
          <WSList gap="2XL">
            <AlertPendingAccountMicroDeposit />
            <AlertNoPayoutMethod />
            <AlertPayoutMethodMissingData />

            <DefaultPayoutMethod />

            <WSElement>
              <DefaultPaymentMethod
                hidable
                onManage={() => {
                  history.push(
                    PATH_SETTINGS_PAYMENT_METHODS_MANAGE_PAYMENT_METHOD
                  );
                }}
                onAddNew={() => {
                  history.push(
                    PATH_SETTINGS_PAYMENT_METHODS_ADD_PAYMENT_METHOD
                  );
                }}
              />
            </WSElement>
          </WSList>
        </WSGrid.Item>
        <WSGrid.Item span={{ m: "5" }}>
          <WSList gap="2XL">
            {!isInternational && <PayoutSplits />}

            {isInternational && <WidgetPlatformBalanceInfo />}

            <WidgetPlatformBalance />

            <WingspanAccounts />
          </WSList>
        </WSGrid.Item>
      </WSGrid>
    </>
  );
};
